import { render, staticRenderFns } from "./package-carton-label.vue?vue&type=template&id=0808b424&scoped=true"
import script from "./package-carton-label.vue?vue&type=script&setup=true&lang=js"
export * from "./package-carton-label.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0808b424",
  null
  
)

export default component.exports